import React from 'react';
import classNames from 'classnames';
import { AnchorId } from '../core/Enums';
import { useTour } from '../core/TourProvider';
import { useTourAnchor } from '../hooks/useTourAnchor';
import TenantInvoiceExpansion from './TenantInvoiceExpansion';
import styles from '../stylesheets/tenantPayments.module.scss';

interface TenantPaymentsProps {
  onMakePayment?: () => void;
}

const TenantPayments = ({ onMakePayment }: TenantPaymentsProps) => {
  const { model } = useTour();
  const makePaymentRef = useTourAnchor(AnchorId.TENANT_PAYMENTS_MAKE_PAYMENT);
  const invoiceAccordionRef = useTourAnchor(
    AnchorId.TENANT_PAYMENTS_INVOICE_ACCORDION
  );
  const invoices = model.payments?.invoices ?? [];
  const outstandingInvoice =
    invoices.find((invoice) => invoice.status === 'outstanding') ?? invoices[0];

  if (!outstandingInvoice) {
    return (
      <div className={styles.emptyState}>
        <h2 className={styles.emptyTitle}>Payments</h2>
        <p className={styles.emptyBody}>No outstanding invoices.</p>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <h2 className={styles.unitTitle}>{model.tenant.unitName}</h2>
          <h3 className={styles.unitSubtitle}>{model.tenant.propertyName}</h3>
        </div>
      </header>

      <section className={styles.section}>
        <div ref={invoiceAccordionRef}>
          <TenantInvoiceExpansion
            invoice={outstandingInvoice}
            headerLeftMainText={model.tenant.unitName}
          />
        </div>
        <button
          type="button"
          className={styles.reviewButton}
          onClick={onMakePayment}
          ref={makePaymentRef}
        >
          Make a payment
        </button>
      </section>
    </div>
  );
};

export default TenantPayments;
